module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    class: {
      'u-mt4': _vm.loading
    }
  }, [(_vm.claim) ? _c('div', {
    staticClass: "claim-block"
  }, [_c('div', {
    staticClass: "claim-description u-mb4"
  }, [_c('div', {
    staticClass: "claim-description__main"
  }, [_c('div', {
    staticClass: "claim-description__title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.t('claims.claim_#', {
    number: _vm.claim.claim_number
  })))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getLossDate))])]), _vm._v(" "), _c('div', {
    staticClass: "claim-description__title_subtitle"
  }, [_vm._v("\n          " + _vm._s(_vm.t('claims.policy_select_prefix')) + _vm._s(_vm.claim.policy.policy_number) + "\n        ")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [(_vm.policy.gen2_auto) ? _c('h3', {
    staticClass: "subheader"
  }, [_vm._v(_vm._s(_vm.t('auto.accident_address_heading')))]) : _c('h3', {
    staticClass: "subheader"
  }, [_vm._v(_vm._s(_vm.t('claims.location_title')))]), _vm._v(" "), _c('div', {
    staticClass: "claim-description__content"
  }, [_c('div', [_vm._v(_vm._s(_vm.claim.loss_address.addressLine1))]), _vm._v(" "), (_vm.claim.loss_address.addressLine2) ? _c('div', [_vm._v(_vm._s(_vm.claim.loss_address.addressLine2))]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n              " + _vm._s(_vm.claim.loss_address.addressCity) + ", " + _vm._s(_vm.claim.loss_address.addressState) + ", " + _vm._s(_vm.claim.loss_address.addressZip) + "\n            ")])]), _vm._v(" "), (_vm.insuredContactNumber) ? _c('div', [_c('h3', {
    staticClass: "subheader"
  }, [_vm._v(_vm._s(_vm.t('global.phone_number')))]), _vm._v(" "), _c('div', {
    staticClass: "claim-description__content"
  }, [_c('bc-phone-national-format', {
    attrs: {
      "phone": _vm.insuredContactNumber
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.policy.gen2_auto && _vm.claimVehicles.length > 0) ? _c('div', [_c('h3', {
    staticClass: "subheader"
  }, [_vm._v(_vm._s(_vm.t('auto.vehicles')))]), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', [_vm._v(_vm._s(vehicle))])
  })], 2) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('h3', {
    staticClass: "subheader"
  }, [_vm._v(_vm._s(_vm.t('claims.loss_description_title')))]), _vm._v(" "), _c('div', {
    staticClass: "claim-description__content claim-description__content_scroll"
  }, [_vm._v(_vm._s(_vm.claim.description))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "u-mb4"
  }, [(!_vm.hideClaimsLossPhotos) ? _c('bc-claim-photo-preview', {
    attrs: {
      "photos": _vm.claim.photos,
      "photosPending": _vm.photosPending
    },
    on: {
      "reloadClaimImage": _vm.loadClaim
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.hideClaimsAdjusters) ? _c('div', [_c('h2', {
    staticClass: "secondary-title u-mb3"
  }, [_vm._v("\n        " + _vm._s(_vm.t('claims.adjusters_section_title')) + "\n        "), (_vm.claim.adjusters && _vm.claim.adjusters.length > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.claim.adjusters.length) + ")")]) : _vm._e()]), _vm._v(" "), (_vm.claim.adjusters.length) ? _c('div', _vm._l((_vm.claim.adjusters), function(adjuster) {
    return _c('div', {
      key: adjuster.id,
      staticClass: "claim-adjusters u-mb4"
    }, [_c('bc-adjusters-list', {
      attrs: {
        "name": adjuster.name,
        "imageData": {
          photoId: adjuster.photo_id
        },
        "contact": adjuster
      }
    })], 1)
  }), 0) : _c('div', {
    staticClass: "claim-adjusters u-mb4"
  }, [(!_vm.claim.adjusters.length) ? _c('div', {
    staticClass: "u-mt2 u-mb4"
  }, [_vm._v("\n          " + _vm._s(_vm.t('claims.claim_no_adjusters_yet_text')) + "\n        ")]) : _vm._e()])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}